export default __webpack_public_path__ + "static/media/gallery_02.4c7e0bbb.jpg";